import { UserModuleType } from "@tm/models"
import { useMemo } from "react"
import { useUser } from "../../user"
import { getModuleFromUserContext } from "../../helper"

export function useCisModule() {
    const { userContext } = useUser()
    return useMemo(() => {
        const cisModule = getModuleFromUserContext(userContext, UserModuleType.CustomerInformation)
        return {
            hasCis: !!cisModule, // boolean indicating whether the current user has the CIS module enabled.
            hasModuleCosts: cisModule?.moduleCosts,
        }
    }, [userContext])
}
